<template>
  <div>
    <v-menu nudge-top="10" nudge-left="5" top offset-y>
      <template v-slot:activator="{ on }">
        <v-btn class="language-switcher" v-on="on">
          <span> {{ languageName }} </span>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="lang in languages"
          :key="lang.code"
          @click="selectLanguage(lang.code)"
        >
          <v-list-item-title>
            <span>{{ lang.name }}</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { reactive, toRefs, computed, watch } from "../../plugins/compositionApi";
import languageLoader from "../../service/languageLoader";
import locale from "../../service/locale";
import { getConfiguration } from "../../service/main";

export default {
  name: "LanguageSelection",
  setup() {
    const state = useComponentState();
    const { loadCrowdin } = setupCrowdin(state);
    return {
      ...toRefs(state),
      loadCrowdin,
      selectLanguage: locale.setLanguage
    };
  }
};

function useComponentState() {
  const state = reactive({
    languages: languageLoader.info,
    currentLanguage: computed(() => locale.getCurrentLanguage()),
    languageName: computed(() => state.languages[state.currentLanguage].name)
  });
  return state;
}

function setupCrowdin(state) {
  function loadCrowdin() {
    const config = getConfiguration();
    if (config.crowdinIntegration && state.currentLanguage === "aa") {
      window._jipt = [];
      if (config.projectId == 'BusinessPortal') {
        window._jipt.push(["project", "eagle-eye-networks"])
      } else window._jipt.push(["project", "CameraManager"]);
      let scr = document.createElement("script");
      scr.src = "//cdn.crowdin.com/jipt/jipt.js";
      scr.setAttribute("id", "crowdin-script");
      document.getElementsByTagName("head")[0].appendChild(scr);
    } else {
      let el = document.getElementById("crowdin-script");
      if (el) {
        el.parentNode.removeChild(el);
        location.reload();
      }
    }
  }
  watch(
    () => state.currentLanguage,
    () => loadCrowdin()
  );
  return { loadCrowdin };
}


</script>

<style lang="scss" scoped>

span {
  vertical-align: middle;
}

.dropdown {
  margin-right: 10px;
  align-items: center;
}
.dropdown .option {
  width: 120px;
}
a.dropdown-item {
  display: flex;
}
.lang-icon {
  width: 32px;
  margin-right: 5px;
}
a.dropdown-item .lang-name {
  padding-top: 7px;
  padding-left: 5px;
}

.dropdown-menu {
  z-index: 1001;
}
</style>
